import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import AdSense from 'react-adsense';
import { Cookies } from '../../index.js';
import { alert_error , alert_success  } from '../../AppContext.js';
const SuccessBanner = ({ truyen }) => {
  const [showBanner, setShowBanner] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const handleCaptchaVerify = async (token) => {
    if ( !truyen )
    {
        alert_error('Lỗi không lấy được thông tin truyện') ;
    }
    else
    {
        try {
            // Gửi mã token Recaptcha và kiểm tra xác thực
            const myCookieValue = Cookies.get('apikey');
            const response = await axios.post('https://hust.media/giai-tri/truyen-chu/xacnhandoctruyen.php', {
                captcha: token,
                apikey: myCookieValue,
                truyen: truyen
              });
            if (response.data) {
             const   status = response.data.status ;
              if ( status == 1 )
              {  
                alert_success(response.data.message) ; 
                setCaptchaVerified(true);
                setShowBanner(true);
              }
              else 
              {
                alert_error(response.data.message) ; 
                setShowBanner(false);
                setCaptchaVerified(true);
              }
            } else {
              // Xử lý khi xác thực thất bại
            }
          } catch (error) {
              alert_error(error) ; 
          }
    }
 
  };

  const handleBannerClose = () => {
    setShowBanner(false);

  };

  const handleCaptchaChange = (value) => {
    if (value) {
      handleCaptchaVerify(value);
    }
  };

  return (
    <>
      {showBanner && (
        <div className="fixed bottom-0 left-0 right-0 bg-green-500 p-4 text-white mb-10">
          <p className="text-center">
            Xác nhận đọc truyện thành công!
          </p>
          <button
            className="mt-0 bg-white text-green-500 px-3 py-2 rounded"
            onClick={handleBannerClose}
          >
            Đóng
          </button>
        </div>
      )}
      {!captchaVerified && (
        <div className="flex flex-col items-center mt-0">
          <div className="text-center text-base">Xác nhận đọc truyện nhận 3 Coins </div>
          <ReCAPTCHA
            sitekey="6LeB3qclAAAAAGkFcUEAgX8Lmi37Frx0m7UUImEN"
            onChange={handleCaptchaChange}
          />
        </div>
      )}
             
    </>
  );
};

export default SuccessBanner;
